<template>
  <div class="home">
    <div class="main-box">
      <div class="w1280">
        <div class="buyticket">
          <div class="pane" v-show="currentTab===0">
            <!-- 左箭头 -->
            <img v-if="datePlaneIndex === 2" class="jiantou1" src="@/assets/images/home/jiantou3.png" alt="" @click="datePlaneIndex = 1">
            <!-- 右箭头 -->
            <img v-if="datePlaneIndex === 1" class="jiantou2" src="@/assets/images/home/jiantou4.png" alt=""  @click="datePlaneIndex = 2">
            <div class="buyticket-box">
              <div class="buyticket-div">
                <span class="title"><img src="../assets/images/home/date.png"/>{{$t('buyTicket.selectAVisitDate')}}</span>
                <div class="buyticket-right buyticket-shadow">
                  <div class="date-box date-box-title">
                    <div>{{$t('buyTicket.Monday')}}</div>
                    <div>{{$t('buyTicket.Tuesday')}}</div>
                    <div>{{$t('buyTicket.Wednesday')}}</div>
                    <div>{{$t('buyTicket.Thursday')}}</div>
                    <div>{{$t('buyTicket.Friday')}}</div>
                    <div>{{$t('buyTicket.Saturday')}}</div>
                    <div>{{$t('buyTicket.Sunday')}}</div>
                  </div>
                  <div v-if="datePlaneIndex === 1">
                    <div class="date-box">
                      <div @click="bindDateChange(item,0)" :class="['date-item', item.isOpen?'date-item-open':'date-item-noopen', item.isActive?'date-item-isActive':'']"
                      v-for="(item, index) in dateList[0]" :key="index">
                        <span v-if="languageCode === 'Korean'">{{item.date.split('-')[1] + '월' + item.date.split('-')[2] + '일'}}</span>
                        <span v-else-if="languageCode === 'English'">{{englishMonth[item.date.split('-')[1]] + ' ' + item.date.split('-')[2] }}</span>
                        <span v-else>{{item.date.split('-')[1] + '月' + item.date.split('-')[2] + '日'}}</span>
                      </div>
                    </div>
                    <div class="date-box">
                      <div @click="bindDateChange(item,1)" :class="['date-item', item.isOpen?'date-item-open':'date-item-noopen', item.isActive?'date-item-isActive':'']"
                      v-for="(item, index) in dateList[1]" :key="index">
                        <span v-if="languageCode === 'Korean'">{{item.date.split('-')[1] + '월' + item.date.split('-')[2] + '일'}}</span>
                        <span v-else-if="languageCode === 'English'">{{englishMonth[item.date.split('-')[1]] + ' ' + item.date.split('-')[2] }}</span>
                        <span v-else>{{item.date.split('-')[1] + '月' + item.date.split('-')[2] + '日'}}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="datePlaneIndex === 2">
                    <div class="date-box">
                      <div @click="bindDateChange(item,2)" :class="['date-item', item.isOpen?'date-item-open':'date-item-noopen', item.isActive?'date-item-isActive':'']"
                      v-for="(item, index) in dateList[2]" :key="index">
                        <span v-if="languageCode === 'Korean'">{{item.date.split('-')[1] + '월' + item.date.split('-')[2] + '일'}}</span>
                        <span v-else-if="languageCode === 'English'">{{englishMonth[item.date.split('-')[1]] + ' ' + item.date.split('-')[2] }}</span>
                        <span v-else>{{item.date.split('-')[1] + '月' + item.date.split('-')[2] + '日'}}</span>
                      </div>
                    </div>
                    <div class="date-box">
                      <div @click="bindDateChange(item,3)" :class="['date-item', item.isOpen?'date-item-open':'date-item-noopen', item.isActive?'date-item-isActive':'']"
                      v-for="(item, index) in dateList[3]" :key="index">
                        <span v-if="languageCode === 'Korean'">{{item.date.split('-')[1] + '월' + item.date.split('-')[2] + '일'}}</span>
                        <span v-else-if="languageCode === 'English'">{{englishMonth[item.date.split('-')[1]] + ' ' + item.date.split('-')[2] }}</span>
                        <span v-else>{{item.date.split('-')[1] + '月' + item.date.split('-')[2] + '日'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buyticket-div">
                <span class="title"><img src="../assets/images/home/time.png"/>{{$t('buyTicket.selectAVisitTime')}}</span>
                <div class="buyticket-right">
                  <div class="select-list">
                    <span
                      @click="radioChange(item)"
                      v-for="(item,index) in timeSharing"
                      :key="index"
                      :class="[index&&(index + 1)%4===0?'noMR':'',item.isCheck?'active':'' , item.canReservationSanke === 'F' ? 'disable' : '']"
                    >
                      <p>{{item.reservationBeginTime}}~{{item.reservationEndTime}}</p>
                      <p v-if="item.canReservationSanke !== 'F'">{{$t('buyTicket.ticketBalance')}}：{{item.surplusStockNum}}</p>
                      <p v-else>{{item.nopastDue?$t('buyTicket.ticketBalance') + '：0': $t('buyTicket.notBooking')}}</p>
                    </span>
                  </div>
                </div>
              </div>
              <div class="buyticket-div">
                <span class="title"><img src="../assets/images/home/product.png"/>{{$t('buyTicket.selectTicketType')}}</span>
                <div class="buyticket-right buyticket-shadow">
                  <el-table
                    :data="ticketList"
                    class="buyticket-list"
                    :key="tableKey"
                    style="width: 100%"
                    :header-cell-style="{background:'#F1F6FF'}">
                  >
                    <el-table-column align="center" :label="$t('buyTicket.productName')" prop="ticketName">
                      <template slot-scope="scope">
                        <span>{{scope.row.ticketName}}</span>
                        <p v-if="scope.row.isOpenTicketDetail === 'T'" @click="ticketKindVOListShow(scope.row.ticketDetail)" style="color:#737B8C;cursor: pointer;">{{$t('buyTicket.ticketingInstructions')}} >></p>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" :label="$t('buyTicket.ticketType')" prop="ticketKindName">
                      <template slot-scope="scope">
                        <span>{{scope.row.ticketKindName}}</span>
                        <p v-if="scope.row.needTicketKindNotice === 'T'" v-html="scope.row.ticketKindNotice" style="color:#737B8C;"></p>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" :label="$t('buyTicket.UnitPrice')">
                      <template slot-scope="scope">
                        <span>￥{{scope.row.salePrice}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" :label="$t('buyTicket.Quantity')">
                      <template slot-scope="scope">
                        <el-input-number
                          v-model="scope.row.selectNum"
                          :min="0"
                          :max="maxQuantit && scope.row.isOpenPurchasing === 'T' ? cs(scope.$index) : Infinity"
                          @change="selectNumChage()"
                        ></el-input-number>
                      </template>
                    </el-table-column>
                    <div slot="empty" class="empty">
                      <span>请先选择检票进场时段</span>
                    </div>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="buyticket-div buyticket-hint">
              <img src="../assets/images/home/hint.png"/>{{$t('buyTicket.maxNum').replace(new RegExp('&valItem'), maxQuantit)}}
            </div>
            <div v-show="timeSharingSelect" style="text-align: right;">
              <span style="
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #687280;">
                <span>{{$t('buyTicket.Total')}}：<b style="font-size: 20px;">{{$t('buyTicket.totalNum').replace(new RegExp('&valItem'), allSelectNumber)}}</b>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span>{{$t('buyTicket.TotalPrice')}}：<b style="color: #F72A2A;font-size: 20px;">￥{{allPrice}}</b>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </span>
              <span class="payBtn" @click="reserve()">{{$t('buyTicket.placeOrder')}}</span>
            </div>
            <!-- 购票进度 -->
            <ProgressPanel :activitiesIndex='activitiesIndex'></ProgressPanel>
          </div>
        </div>
        <!-- 最新公告 -->
        <div class="announcements" v-if="languageCode === 'Simplified_Chinese'">
          <div class="title">
            <span>{{$t('buyTicket.LatestAnnouncement')}}</span>
            <span @click="lookMore">{{$t('buyTicket.viewMore')}} ></span>
          </div>
          <div class="list">
            <div class="list-item" v-for="(item, index) in articleList" :key="index"  @click="articleDetail(item)">
              <div class="list-item-left">{{item.title}}</div>
              <div class="list-item-right">{{item.crtTime}}</div>
            </div>
          </div>
        </div>
        <!-- 预约须知 -->
        <div class="information">
          <div class="title">
            <span>{{$t('buyTicket.ticketingInstructions')}}</span>
          </div>
          <div class="content">
            <div v-html="notice"></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      custom-class="notice-dialog"
      width="60%"
      height="50%"
      :show-close="false"
      title
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div class="title">{{$t('buyTicket.ticketingInstructions')}}</div>
      <div class="notice panel-body">
        <span v-html="notice"></span>
        <!-- <div class="c-r mt20">暂不接待中、高风险等级地区的观众及14日内有中、高风险等级地区旅居史的观众。</div>
        <div class="c-r">来陕返陕观众需持检票时48小时内的核酸检测阴性证明方可入园，14日内未离陕人员，持行程卡和健康码绿码前往检票入园。</div> -->
      <!-- <div class="flex-between">
        <span class="mr20">您是否来自中、高风险等级地区或14日内有中、高风险等级地区旅居史？</span>
        <el-radio-group v-model="isFromRisk">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </div>
      <div class="flex-between">
        <span class="mr20">省外观众或14天内有省外旅居史的本省观众，是否有48小时内核酸检测报告阴性证明？（参观时需现场查验）</span>
        <el-radio-group v-model="isHasReport">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </div> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="c-r">请仔细阅读购票须知！</div>
        <el-button v-if="!agree" class="cancal" :disabled="false" type="info">{{$t('buyTicket.PleaseRead')}}（{{codeText}}S)</el-button>
        <el-checkbox
          v-else
          class="selctes"
          style="background:#241008;color:#fff;padding:12px 20px;border-radius: 4px"
          v-model="checkStatus"
          @change="handleNoticeChange"
        >{{$t('buyTicket.IRead')}}</el-checkbox>
        <!-- <el-button

          @click="dialogVisible = false"

        >我已详细阅读，继续预定</el-button>-->
      </span>
    </el-dialog>
    <el-dialog
      custom-class="notice-dialog"
      width="40%"
      height="50%"
      :show-close="false"
      title
      :visible.sync="dialogVisibleTicket"
      :close-on-click-modal="false"
    >
      <div class="title">{{$t('buyTicket.ticketingInstructions')}} <i @click="dialogVisibleTicket=false" style="float: right;cursor: pointer;" class="el-icon-close"></i></div>
      <span class="notice panel-body" v-html="noticeTicket"></span>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancal" @click="dialogVisibleTicket=false" type="primary">{{$t('buyTicket.IRead')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog title="登录提示" :visible.sync="centerDialogVisible" width="30%">
      <div class="dialog-tip">您还未登录，请用微信扫码登录</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="nanputuo-cancel" @click="centerDialogVisible = false">取 消</el-button>
        <el-button class="nanputuo-confirm" type="primary" @click="handleToLogin">去登录</el-button>
      </span>
    </el-dialog>
    <el-dialog title :visible.sync="dialogLogin" width="30%">
      <div class="dialog-login">
        <iframe id="frame" :src="iframeUrl" frameborder="0"></iframe>
      </div>
    </el-dialog>
    <el-dialog
      custom-class="notice-dialog"
      width="40%"
      height="50%"
      :show-close="false"
      title
      :visible.sync="dialogErrorVisible"
    >
      <div class="title">停用提醒</div>
      <span class="notice">{{remark|| $t('buyTicket.noDataAvailable')}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn cancal" @click="dialogErrorVisible = false">{{$t('Close')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ProgressPanel from '../components/ProgressPanel'
import { dateFtt } from '../common/js/common'
import { config } from '@/constant/config'
import * as math from 'mathjs'
import { formatDate } from '@/utils/utils'
import { getToken, allowSaleList, flightLineList, allowFerrySaleList, sysConfig, reservationConfig, reservationDaily,
  Login, standByList, getPreSaleDays, maxQuantit, getGoodsInfo, getLatestAnnouncement } from '@/api/buyTicket'
export default {
  components: {
    ProgressPanel
  },
  data () {
    return {
      isFromRisk: null,
      isHasReport: null,
      datePlaneIndex: 1,
      termsOfServiceshow: false,
      loginShow: false,
      registShow: false,
      registType: 0,
      currentDate: '',
      tomorrowDate: '',
      date: [],
      dateList: [],
      checkStatus: false,
      form: {},
      dialogVisible: false,
      list: [],
      allSelectNumber: 0,
      allPrice: 0,
      articleList: null,
      week: [
        { cn: '一', en: 'MON' },
        { cn: '二', en: 'TUE' },
        { cn: '三', en: 'WED' },
        { cn: '四', en: 'THU' },
        { cn: '五', en: 'FRI' },
        { cn: '六', en: 'SAT' },
        { cn: '日', en: 'SUN' }
      ],
      englishMonth: {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sept',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dec'
      },
      pickerOptions: {
        disabledDate (time) {
          const curDate = (new Date()).getTime()
          // 这里算出一个月的毫秒数,
          const day = 14 * 24 * 3600 * 1000
          const bday = 2 * 24 * 3600 * 1000
          const dateRegion = curDate + day
          return time.getTime() < curDate + bday ||
          time.getTime() > dateRegion
        }
      },
      ordinarypickerOptions: {
        disabledDate (time) {
          const curDate = (new Date()).getTime()
          // 这里算出一个月的毫秒数,
          const day = 14 * 24 * 3600 * 1000
          const dateRegion = curDate + day
          return time.getTime() < curDate ||
          time.getTime() > dateRegion
        }
      },
      flag: false,
      tiketType: 'spot',
      flightLineList: [],
      tabIndex: 0,
      ReservationConfig: {},
      timeSharingIndex: null,
      selectDate: '',
      timeSharing: [],
      dateBox: [],
      valueDate: '',
      selectNum: 1,
      ticketList: [],
      customize: '',
      LoginBtnShow: false,
      centerDialogVisible: false,
      disable: false,
      iframeUrl: '',
      dialogLogin: false,
      dialogErrorVisible: false,
      remark: '',
      tableKey: 0,
      currentTab: 0,
      ordinaryValueDate: null,
      notice: '',
      isOpenNotice: false,
      codeText: 5,
      agree: false,
      banner: [],
      welcome: '',
      logo: '',
      oldticketList: null,
      timeSharingSelect: false,
      path: null,
      maxQuantit: null,
      noticeTicket: '',
      dialogVisibleTicket: false,
      pageIndex: '1',
      activitiesIndex: 0,
      scheduledTime: 10,
      languageCode: null
    }
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  computed: {
    cs () {
      return (data) => {
        let allSelect = 0
        let maxQuantit = this.maxQuantit
        this.ticketList.forEach((item, index) => {
          if (item.isOpenPurchasing === 'T' && index !== data) {
            allSelect += item.selectNum
          }
        })

        return maxQuantit - allSelect
      }
    }
  },
  async created () {
    this.languageCode = localStorage.getItem('languageCode') || 'Simplified_Chinese'
    this.scheduledTime = await this.getPreSaleDays()
    this.initDate()
    this.init()
    // this.getList()
    this.getmaxQuantit()
  },
  mounted () {
    this.pageIndex = this.$route.query.index || '1'
  },
  methods: {
    // 获取系统参数配置的最大下单数
    getmaxQuantit () {
      maxQuantit().then(res => {
        if (res.code === 0) {
          this.maxQuantit = parseInt(res.data.value) || Infinity
          localStorage.setItem('MaxQuantit', this.maxQuantit)
        } else {
          console.error(res.error)
        }
      })
    },
    lookMore () {
      this.$router.push('/announcementList')
    },
    articleDetail (item) {
      this.$router.push({
        path: '/articleDetail',
        query: {
          item: JSON.stringify(item)
        }
      })
    },
    // 初始化日期显示
    initDate () {
      const today = new Date()
      let todayWeek = today.getDay()
      todayWeek = todayWeek === 0 ? 7 : todayWeek
      const dayArr = []
      // 今天之前的日期
      for (let i = 0; i < todayWeek - 1; i++) {
        const date = formatDate('yyyy-MM-dd', new Date(today.getTime() - 86400000 * (todayWeek - i - 1)))
        const obj = {
          date,
          day: new Date(date).getDate(),
          isActive: false
        }
        dayArr.push(obj)
      }
      // 当天
      const todayObj = {
        date: formatDate('yyyy-MM-dd', today),
        day: new Date(today).getDate(),
        isOpen: false,
        isToday: true,
        isActive: false,
        isDis: true
      }
      dayArr.push(todayObj)
      // 当天后的6天
      for (let i = 0; i <= 6; i++) {
        const date = formatDate('yyyy-MM-dd', new Date(today.getTime() + 86400000 * (i + 1)))
        const obj = {
          date,
          day: new Date(date).getDate(),
          isOpen: false,
          isActive: false
        }
        dayArr.push(obj)
      }
      const len = dayArr.length
      // 补足14天
      if (len !== 7) {
        for (let i = 0; i < 28 - len; i++) {
          const date = formatDate('yyyy-MM-dd', new Date(today.getTime() + 86400000 * (i + 8)))
          const obj = {
            date,
            day: new Date(date).getDate(),
            text: '不可预约',
            isOpen: false,
            isActive: false
          }
          dayArr.push(obj)
        }
      }
      let toDayIndex = dayArr.findIndex(item => item.isToday)
      this.dayArr = dayArr
      const arr1 = []
      const arr2 = []
      const arr3 = []
      const arr4 = []

      dayArr.forEach((val, index) => {
        if (index <= (toDayIndex + this.scheduledTime) && index >= toDayIndex) {
          val.isDis = true
        }
        if (index < 7) {
          arr1.push(val)
        } else if (index < 14) {
          arr2.push(val)
        } else if (index < 21) {
          arr3.push(val)
        } else {
          arr4.push(val)
        }
      })
      this.dateList.push(arr1)
      this.dateList.push(arr2)
      this.dateList.push(arr3)
      this.dateList.push(arr4)
    },
    tiggerPage (index) {
      this.pageIndex = index
    },
    selectNumChage () {
      let allSelectNumber = 0
      let allPrice = 0
      this.ticketList.forEach(item => {
        allSelectNumber += item.selectNum
        allPrice += Number(item.salePrice) * item.selectNum
      })
      if (allSelectNumber > 0) {
        this.activitiesIndex = 3
      } else {
        this.activitiesIndex = 2
      }
      this.allSelectNumber = allSelectNumber
      this.allPrice = allPrice
    },
    ticketKindVOListShow (text) {
      if (text) {
        const regExp = /src="[/]?file\/download\//g
        text = text.replace(regExp, `src="${config.BASE_URL}/file/download/`)
      }
      this.noticeTicket = text
      this.dialogVisibleTicket = true
    },
    handleNoticeChange () {
      window.setTimeout(() => {
        this.dialogVisible = false
        this.checkStatus = false
      }, 500)
    },
    init () {
      console.log('sessionStorage.getItem()', sessionStorage.getItem('token'), sessionStorage.getItem('loginState'))

      const url = window.location.search
      const str = url.substr(url.indexOf('?'))
      const strs = str.split('&')
      const orgId = strs[0].split('=')[1]
      if (url.indexOf('?') !== -1) {
        sessionStorage.setItem('orgId', orgId)
        if (sessionStorage.getItem('token')) {
          if (sessionStorage.getItem('loginState') === '1') {
            this.LoginBtnShow = true
            this.sysConfig(orgId)
          } else {
            this.sysConfig(orgId, true)
            if (sessionStorage.getItem('loginOutState') !== 'T') { this.dialogVisible = true }
          }
          // 查询预约余票量
          // this.standByList()
          this.getReservationConfig()
          // this.getInfo()
          // 文章
          this.getCategory()
          sessionStorage.setItem('LoginHref', window.location.href)
        } else {
          sessionStorage.setItem('homeHref', window.location.href)
          this.token(orgId)
        }
      } else {
        sessionStorage.setItem('homeHref', window.location.href)
        this.token(orgId)
      }
    },
    getCategory () {
      getLatestAnnouncement({
        'categoryCode': 'LATESTANNOUNCEMENT',
        'clientSide': 'ALL',
        'limit': '100',
        'page': '1',
        'status': 'T',
        'languages': localStorage.getItem('languageCode') || 'Simplified_Chinese'
      }).then(res => {
        if (res.code === 0) {
          this.articleList = res.data.list.slice(0, 12)
        }
      })
    },
    handleTab (num) {
      if (num === this.currentTab) {
        return false
      }
      this.ReservationConfig = {}
      this.timeSharingIndex = null
      if (num === 0) {
        this.getReservationConfig()
      } else if (num === 1) {
        this.getordinaryList()
      }
      this.currentTab = num
    },
    CtoH (str) {
      var result = ''
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) === 12288) {
          result += String.fromCharCode(str.charCodeAt(i) - 12256)
          continue
        }
        if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) result += String.fromCharCode(str.charCodeAt(i) - 65248)
        else result += String.fromCharCode(str.charCodeAt(i))
      }
      return result
    },
    // 获取预售天数
    getPreSaleDays () {
      return new Promise((resolve, reject) => {
        getPreSaleDays().then(res => {
          if (res.code === 0) {
            let value = res.data.value || 10
            // 如果是全角数字需要转换
            if (value.match(/[\uff00-\uffff]/g)) {
              value = this.CtoH(value)
            }
            resolve(parseInt(value))
          } else if (res.code === 1017) {
            this.$message({
              message: '登录过期，安全性提醒：请重新登录',
              type: 'error'
            })
          } else {
            this.$message({
              message: res.error,
              type: 'error'
            })
            resolve(10)
          }
        })
      })
    },
    // 退出登录
    loginOut () {
      this.LoginBtnShow = false
    },
    // 获取普通产品列表
    getordinaryList () {
      const data = {
        useDate: this.ordinaryValueDate,
        orgId: sessionStorage.getItem('orgId'),
        customerType: 'ct_sanke',
        customerId: 'SAN_KE',
        languages: localStorage.getItem('languageCode') || 'Simplified_Chinese'
      }
      allowSaleList(data).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            res.data.map(item => {
              item.quantity = 1
              item.total = 0
              item.salePrice = Number(item.salePrice).toFixed(2)
              item.total = Number(item.total).toFixed(2)
              if (item.isRealname === 'T') {
                item.passengerList = []
              }
              return item
            })
            this.ticketList = res.data
            this.ticketList.selectNum = 0
            this.disable = false
          } else {
            this.ticketList = []
            this.$message({
              message: '该日期无可预约票',
              type: 'error'
            })
            this.disable = true
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
          this.disable = true
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
          this.disable = true
        }
      })
    },
    // 数量修改
    handleQuantityChange () {
      this.totalAmount = 0
      this.selectNum = 0
      this.ticketList.map(item => {
        if (item.quantity < 0 || !item.quantity || item.quantity === null || item.quantity === '') { // 数量为空小于0时
          item.quantity = 0
        }
        item.quantity = parseInt(item.quantity) // 数量输入小点
        item.total = Number(math.format(item.quantity * item.salePrice, 14)).toFixed(2)
        this.selectNum = this.selectNum + item.quantity
        this.totalAmount = Number(math.format(this.totalAmount + item.quantity * item.salePrice, 14))
        return item
      })
      this.totalAmount = Number(this.totalAmount).toFixed(2)
    },
    token (orgId) {
      getToken(orgId).then(res => {
        if (res.code === 0) {
          sessionStorage.setItem('token', res.data)
          // 查询预约余票量
          // this.standByList()
          this.getReservationConfig()
          this.sysConfig(orgId)
          // 文章
          this.getCategory()
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    handleToLogin () {
      this.centerDialogVisible = false
      const returnUrl = window.location.href
      Login(returnUrl).then(res => {
        this.dialogLogin = true
        this.iframeUrl = res
        // window.location = res
      })
    },
    handleOrder () {
      if (this.LoginBtnShow) {
        this.centerDialogVisible = true
      } else {
        console.log(123)
        // this.$router.push('/myOrder')
      }
    },
    handleLogin (path) {
      this.loginShow = true
      this.LoginBtnShow = false
      this.path = path
      // const returnUrl = window.location.href
      // Login(returnUrl).then(res => {
      //   this.dialogLogin = true
      //   this.iframeUrl = res
      //   // window.location = res
      // })
    },
    loginOk () {
      this.getReservationConfig()
      this.sysConfig(sessionStorage.getItem('orgId'))
      this.LoginBtnShow = true
      sessionStorage.setItem('loginState', '1')
      if (this.path === '/myOrder') {
        this.$router.push('/myOrder')
      }
    },
    closeLogin () {
      this.loginShow = false
    },
    clsoeRegist () {
      this.registShow = false
    },
    // closeStatement(){
    //   this.statementShow = !this.statementShow
    // },
    registShowEvent (i) {
      this.registType = i
      this.loginShow = false
      this.registShow = true
    },
    toLogin () {
      this.registShow = false
      this.loginShow = true
    },
    termsOfServiceEvent () {
      this.termsOfServiceshow = !this.termsOfServiceshow
    },
    handleBlur (e) {
      if (!this.customize) {
        this.selectNum = 1
        this.customize = ''
      }
    },
    handleChangeNum (e) {
      this.selectNum = e
    },
    handleNum (num) {
      this.selectNum = num
      this.customize = ''
    },
    // 日期框架选择日期
    handleSaleDate () {
      if (this.currentTab === 0) {
        let selectDate = this.date.find(res => res.date === this.valueDate)
        if (!selectDate) {
          this.valueDate = this.selectDate
          this.date.forEach(i => {
            i.isCheck = false
            i.selectTime = false
          })
          this.$message({
            message: '该日期无预约票',
            type: 'error'
          })
          return false
        }
        if (selectDate.canReservationSanke === 'F') {
          let ids = this.date.findIndex((res, index) => (index <= 2 && res.date === this.valueDate))
          let idsi = this.date.findIndex((res, index) => index > 2 && res.date === this.selectDate)
          if (ids === -1) {
            this.valueDate = ''
          }
          if (idsi > -1) {
            this.valueDate = this.selectDate
          }
          this.$message({
            message: '该日期无预约票',
            type: 'error'
          })
          return false
        }
        this.date.forEach(i => {
          i.isCheck = false
          i.selectTime = false
        })
        this.selectDate = this.valueDate
        this.getstaggeredList()
      } else if (this.currentTab === 1) {
        this.getordinaryList()
      }
    },
    radioChange (data) {
      if (data.canReservationSanke === 'F') {
        this.$message({
          message: '该时段无预约票',
          type: 'error'
        })
        return false
      }
      this.timeSharing.forEach((item, index) => {
        item.isCheck = false
        if (item.id === data.id) {
          item.isCheck = true
          this.timeSharingIndex = index
          this.timeSharingSelect = true
          this.activitiesIndex = 2
          setTimeout(() => {
            this.getList()
          }, 200)
        }
      })
      // 保存是否可以携带儿童
      localStorage.setItem('isCanChildren', data.freeTicketSurplusStockNum)
    },
    // 日期点击选择
    bindDateChange (item, idx) {
      this.dateList[0].forEach(i => {
        i.isActive = false
      })
      this.dateList[1].forEach(i => {
        i.isActive = false
      })
      this.dateList[2].forEach(i => {
        i.isActive = false
      })
      this.dateList[3].forEach(i => {
        i.isActive = false
      })
      item.isActive = true
      if (item.date !== this.selectDate) {
        this.valueDate = ''
        this.selectDate = item.date
        this.ticketList = null
        this.timeSharingSelect = false
        this.activitiesIndex = 1
        this.getstaggeredList()
      }
    },
    getWeek (dateString) {
      let dateArray = dateString.split('-')
      let date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2])
      return '日一二三四五六'.charAt(date.getDay())
    },
    /**
     * @description: 查询固定时间余票量和是否停用
     */
    standByList () {
      console.log(this.dateList, 'dateList')
      const data = {
        orgId: sessionStorage.getItem('orgId'),
        beginDate: this.dateList[0][0].date,
        endDate: this.dateList[3][6].date
      }
      standByList(data).then(res => {
        if (res.code === 0) {
          let arr = []
          arr = res.data.sort(function (a, b) { return a.date > b.date ? 1 : -1 })
          arr.forEach((item, index) => {
            this.dateList[0].forEach(j => {
              if (j.date === item.date && j.isDis) {
                j.isOpen = true
              }
            })
            this.dateList[1].forEach(j => {
              if (j.date === item.date && j.isDis) {
                j.isOpen = true
              }
            })
            this.dateList[2].forEach(j => {
              if (j.date === item.date && j.isDis) {
                j.isOpen = true
              }
            })
            this.dateList[3].forEach(j => {
              if (j.date === item.date && j.isDis) {
                j.isOpen = true
              }
            })
          })
          let ids = res.data.findIndex((value) => (value.canReservationSanke === 'T'))
          if (ids > -1) {
            let index1 = this.dateList[0].findIndex(item => item.date === res.data[ids].date)
            let index2 = this.dateList[1].findIndex(item => item.date === res.data[ids].date)
            if (index1 !== -1) {
              this.dateList[0][index1].isActive = true
              this.selectDate = this.dateList[0][index1].date
            } else if (index2 !== -1) {
              this.dateList[1][index2].isActive = true
              this.selectDate = this.dateList[1][index2].date
            }
            this.activitiesIndex = 1
            this.getstaggeredList()
          }
          this.date = arr
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    /**
   * @description: 查询日期是否开始分时段预约，开启时继续查询当天全部时段数据，未开启分时段预约时直接查询当天可售列表数据
   */
    getReservationConfig () {
      const data = {
        orgId: sessionStorage.getItem('orgId')
      }
      reservationConfig(data).then(res => {
        if (res.code === 0) {
          this.ReservationConfig = res.data
          // 是否开启分时段预约
          if (res.data.isSaleStaggered === 'T') {
            // 查询预约余票量
            this.standByList()
          } else {
            this.timeSharingIndex = null
            this.getList()
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    getstaggeredList () {
      let data = {
        reservationDate: this.selectDate,
        orgId: sessionStorage.getItem('orgId')
      }
      // formatDate
      let nowDateTime = new Date(formatDate('yyyy-MM-dd', new Date())).getTime()
      let selectTime = new Date(this.selectDate).getTime()
      reservationDaily(data).then(res => {
        if (res.code === 0) {
          let timeSharing = []
          let data = res.data
          if (data.length > 0) {
            let ids = data.findIndex(value => value.canReservationSanke === 'T')
            data.forEach((item, index) => {
              if (index === ids) {
                // item.isCheck = true
              } else {
                item.isCheck = false
              }
            })

            // 过滤指定预约时段
            if (config.filterReservationDaily) {
              const filterReservationDaily = config.filterReservationDaily.split('-')
              if (config.isShowFilterReservationDaily) {
                data = data.filter(item => {
                  return (item.reservationBeginTime === filterReservationDaily[0] && item.reservationEndTime === filterReservationDaily[1])
                })
              } else {
                data = data.filter(item => {
                  return (item.reservationBeginTime !== filterReservationDaily[0] && item.reservationEndTime !== filterReservationDaily[1])
                })
              }
            }

            // 已过期的，不可预约的时段显示已售空，没过期的不可预约的显示0
            // 是否当天，大于当天，那都没过期吧？
            if (nowDateTime < selectTime) {
              data.forEach(item => {
                item.nopastDue = true
              })
            } else {
              let nowTimes = new Date(formatDate('yyyy-MM-dd hh:mm:ss', new Date())).getTime()
              data.forEach(item => {
                let selectTimes = new Date(this.selectDate + ' ' + item.reservationBeginTime + ':00').getTime()
                if (nowTimes < selectTimes) {
                  item.nopastDue = true
                } else {
                  item.nopastDue = false
                }
              })
            }

            timeSharing = data
            console.log(timeSharing)
            this.timeSharingIndex = ids
            this.timeSharing = timeSharing
            this.date.forEach(item => {
              delete item.selectTime
              if (item.isCheck) {
                item.selectTime = this.timeSharing[this.timeSharingIndex]
              }
            })
            this.getSelectTime()
          } else {
            this.timeSharingIndex = null
            this.timeSharing = []
          }
          // this.getList()
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    getSelectTime () {
      this.date.forEach(item => {
        if (item.isCheck) {
          this.selectTime = item.selectTime || {}
          this.selectTime.showDate = item.showDate
        }
      })
    },
    handleQuantity () {
      this.list = [...this.list]
    },
    selectToday () {
      this.currentDate = dateFtt('yyyy-MM-dd', new Date())
      this.date = this.currentDate
      if (this.tiketType === 'spot') {
        this.initQuantity()
      } else {
        this.getFerryList()
      }
    },
    sysConfig (orgId, showNotice) {
      this.form = {}
      const data = {
        typeCode: 'PC',
        orgId: orgId,
        languages: localStorage.getItem('languageCode')
      }
      sysConfig(data).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.welcome = res.data.welcomeWords
            this.logo = config.BASE_URL + res.data.banneLogorUrl
            const imgList = res.data.bannerUrl.split(',')
            imgList.forEach(item => {
              this.banner.push(config.BASE_URL + item)
            })
            document.title = res.data.mallName
            if (res.data.notice) {
              const regExp = /src="[/]?file\/download\//g
              res.data.notice = res.data.notice.replace(regExp, `src="${config.BASE_URL}/file/download/`)
            }
            this.notice = res.data.notice
            this.isOpenNotice = res.data.isOpenNotice
            if (res.data.isOpenNotice === 'T') {
              if (localStorage.getItem('dialogVisibleShow') === '1') {
                localStorage.setItem('dialogVisibleShow', '0')
                // this.dialogVisible = true
              }
              this.codeText = res.data.countDown
              this.timer = setInterval(() => {
                if (this.codeText === 0) {
                  this.agree = true
                  clearInterval(this.timer)
                }
                this.codeText--
              }, 1000)
            }
            this.form = res.data
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        }
      })
    },
    handleNotice () {
      this.dialogVisible = true
    },
    selectTomorrow () {
      const tempDate = new Date()
      tempDate.setDate(tempDate.getDate() + 1)
      this.date = dateFtt('yyyy-MM-dd', tempDate)
      if (this.tiketType === 'spot') {
        this.initQuantity()
      } else {
        this.getFerryList()
      }
    },
    initQuantity () {
      if (this.tiketType === 'spot') {
        this.list.map(item => {
          item.quantity = 0
          return item
        })
        this.list = [...this.list]
      } else {
        this.getFerryList()
      }
    },
    reserve (index) {
      if (this.disable) {
        this.$message({
          message: '当前无可预约时段',
          type: 'error'
        })
        return false
      }
      if (!this.LoginBtnShow) {
        // this.handleLogin()
        this.$message.error('请先登录')
      } else {
        let dataList = this.ticketList
        // 开启了分时预约功能
        let quantityNum = 0
        dataList.forEach((item, index) => {
          // item.quantity = this.selectNum
          if (item.isStaggeredReservation === 'T') {
            quantityNum = quantityNum + item.selectNum
          }
        })
        if (this.ReservationConfig && this.ReservationConfig.isLimitStaggeredQuantity === 'T') {
          if (this.timeSharing[this.timeSharingIndex].surplusStockNum < 1) {
            this.$message({
              message: '当前时段余量不足！',
              type: 'error'
            })
            return false
          }
        }
        // 判断选择的数量是否大于余量和配置
        let selectNums = 0
        let totalCount = 0
        dataList.forEach(item => {
          if (item.selectNum > 0) {
            selectNums += item.selectNum
            if (item.isOpenPurchasing === 'T') {
              totalCount += item.selectNum
            }
          }
        })
        if (selectNums <= 0) {
          this.$message.error('请选择产品')
          return false
        }
        if (totalCount > this.maxQuantit) {
          this.$message.error('单次最多购买数量：' + this.maxQuantit)
          return false
        }
        if (selectNums > this.timeSharing[this.timeSharingIndex].surplusStockNum) {
          this.$message.error('当前时间段余量' + this.timeSharing[this.timeSharingIndex].surplusStockNum)
          return false
        }
        dataList = dataList.filter(item => {
          return item.selectNum > 0
        })
        const query = {
          dataList: JSON.stringify(dataList)
        }
        if (this.ReservationConfig && this.ReservationConfig.isSaleStaggered === 'T') {
          query.reservationId = this.timeSharing[this.timeSharingIndex].id
        } else {
          query.selectDate = this.selectDate
        }
        this.$router.push({
          path: '/fillInOrder',
          query
        })
      }
    },
    // 请求门票列表
    getList () {
      const data = {
        useDate: this.selectDate,
        orgId: sessionStorage.getItem('orgId'),
        customerType: 'ct_sanke',
        customerId: 'SAN_KE',
        languages: localStorage.getItem('languageCode') || 'Simplified_Chinese'
      }
      if (this.timeSharingIndex === -1) {
        this.$message({
          message: '当前无可预约时段',
          type: 'error'
        })
        this.disable = true
        return false
      } else {
        this.disable = false
      }
      if (this.timeSharingIndex !== null) {
        data.staggeredReservationDailyId = this.timeSharing[this.timeSharingIndex].id
      }
      allowSaleList(data).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            res.data.map(async item => {
              let goodsInfo = await getGoodsInfo(item.ticketId)
              if (goodsInfo.code === 0) {
                let goodsIndex = (goodsInfo.data.ticketKindVOList || []).findIndex(jitem => jitem.id === item.ticketKindId)
                let language = localStorage.getItem('languageCode') || 'Simplified_Chinese'
                if (goodsIndex !== -1) {
                  item.ticketKindVOList = goodsInfo.data.ticketKindVOList[goodsIndex]
                  item.needSpecialCertificate = goodsInfo.data.ticketKindVOList[goodsIndex].needSpecialCertificate
                  item.needTicketKindNotice = goodsInfo.data.ticketKindVOList[goodsIndex].needTicketKindNotice
                  // 票种
                  let languageIndex = goodsInfo.data.ticketKindVOList[goodsIndex].ticketKindLanguageConfigVOS.findIndex(langeItem => langeItem.languages === language)
                  if (languageIndex !== -1) {
                    item.ticketKindName = goodsInfo.data.ticketKindVOList[goodsIndex].ticketKindLanguageConfigVOS[languageIndex].ticketKindName
                    item.ticketKindNotice = goodsInfo.data.ticketKindVOList[goodsIndex].ticketKindLanguageConfigVOS[languageIndex].ticketKindNotice
                  } else {
                    item.ticketKindName = ''
                  }
                }

                // 产品须知
                if (goodsInfo.data.ticketLanguageConfigVOS && goodsInfo.data.ticketLanguageConfigVOS.length > 0) {
                  let languageIndex = goodsInfo.data.ticketLanguageConfigVOS.findIndex(langeItem => langeItem.languages === language)
                  if (languageIndex !== -1) {
                    item.ticketDetail = goodsInfo.data.ticketLanguageConfigVOS[languageIndex].ticketDetail
                  } else {
                    item.ticketDetail = ''
                  }
                }
              }
              item.quantity = 1
              item.total = 0
              item.salePrice = Number(item.salePrice).toFixed(2)
              item.total = Number(item.total).toFixed(2)
              if (item.isRealname === 'T') {
                item.passengerList = []
              }
              item.certificateTypeList = item.certificateTypeList || []
              return item
            })
            let ticketList = []
            res.data.forEach(item => {
              if (item.isStaggeredReservation === 'T') {
                item.selectNum = 0
                ticketList.push(item)
              }
            })
            this.ticketList = ticketList
            this.selectNum = 0
          } else {
            this.ticketList = []
            this.$message({
              message: '该时段无可预约票',
              type: 'error'
            })
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    // 请求航线
    getFlightLine () {
      flightLineList().then(res => {
        if (res.code === 0) {
          this.flightLineList = res.data
          this.getFerryList()
        }
      })
    },
    handleChangeFlightLine (index) {
      this.tabIndex = index
      this.getFerryList()
    },
    // 请求航班列表
    getFerryList () {
      const param = {
        useStartDate: this.date + ' 00:00:00',
        flightLineId: this.flightLineList[this.tabIndex].number
      }
      allowFerrySaleList(param).then(res => {
        if (res.code === 0) {
          this.list = res.data
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    handleChangeTiketType (val) {
      this.list = []
      if (val === 'ferry') {
        this.getFlightLine()
      } else {
        this.getList()
      }
    },
    reserveFerry (row) {
      this.$router.push({
        path: '/fillInOrderFeery',
        query: {
          flightLineId: this.flightLineList[this.tabIndex].number,
          flightLineName: this.flightLineList[this.tabIndex].name,
          useStartDate: this.date,
          flightDetail: JSON.stringify(row)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.mr20 {
  margin-right: 20px;
}
.mt20 {
  margin-top: 20px;
}
.c-r {
  margin-bottom: 10px;
  color: red;
}
.home {
  // background: url("../assets/images/home/bg.png")
}
.tiketType_box {
  margin-top: 20px;
  padding-bottom: 50px;
}
.marquee-box {
  // position: fixed;
  padding-top: 79px;
  top: 80px;
  width: 100%;
}
.marquee-title {
  float: left;
  width: 58px;
  line-height: 58px;
  height: 58px;
  margin-right: 18px;
}
.marquee-title span {
  display: inline-block;
  color: #FF0000;
  font-size: 14px;
  font-weight: bold;
  vertical-align: middle;
}
.marquee-title img {
  display: inline-block;
  width: 15px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}
marquee {
  overflow: hidden;
  float: left;
  width: calc(100% - 76px);
  display: block;
  line-height: 58px;
  color: #FF0000;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  height: 58px;
  font-size: 14px;
}

.noticeBtn {
  cursor: pointer;
  float: right;
  line-height: 40px;
  text-align: center;
  background-color: #ffb000;
  padding: 0 15px;
  border-radius: 20px;
  &:hover {
    opacity: 0.8;
  }
  .ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    vertical-align: middle;
    background: url(../assets/images/notice.png) no-repeat;
    background-size: 100% 100%;
    margin-right: 10px;
  }
  .text {
    vertical-align: middle;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
}

.buyticket {
  // margin-bottom: 40px;
  border-radius: 5px;
  .tab {
    overflow: hidden;
    span {
      float: left;
      width: 130px;
      height: 100%;
      line-height: 44px;
      border-radius: 6px;
      overflow: hidden;
      font-style: normal;
      font-size: 14px;
      background: #fff;
      text-align: center;
      cursor: pointer;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-right: 10px;
      &.active {
        background: #241008;
        color: #fff;
      }
    }
  }
  .pane {
    position: relative;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 0px rgba(20, 34, 44, 0.15);
    padding: 30px 60px;
    .jiantou1 {
      position: absolute;
      top: 130px;
      left: 230px;
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
    .jiantou2 {
      position: absolute;
      top: 130px;
      right: 20px;
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
    .buyticket-box {
      overflow: hidden;
      .buyticket-div {
        overflow: hidden;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
        .title {
          display: flex;
          font-size: 16px;
          color: #2D3E54;
          font-weight: bold;
          line-height: 26px;
          height: 46px;
          max-width: 200px;
          img {
            width: 24px;
            height: 24px;
            margin-right: 5px;
          }
        }
        .buyticket-shadow {
          box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
        }
        .buyticket-right {
          overflow: hidden;
          width: 943px;
          position: relative;
          // box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
          .date-box-title {
            height: 48px;
            line-height: 48px;
            background: #F1F6FF;
            opacity: 1;
            border-radius: 8px 8px 0px 0px;
            div {
              width: 134px;
              text-align: center;
            }
          }
          .date-box {
            display: flex;
            justify-content: space-between;
            .date-item {
              width: 134px;
              text-align: center;
              height: 58px;
              line-height: 58px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #424855;
              opacity: 0.5;
              margin: 10px;
              cursor: pointer;
            }
            .date-item-open {
              color: #4E5F84;
              opacity: 1;
              border-radius: 4px;

            }
            .date-item-noopen {
              pointer-events: none;
            }
            .date-item-isActive {
              background: #A0393E;
              color: #FFFFFF;
            }
          }
          .select-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            .noMR {
              margin-right: 0 !important;
            }
            > span {
              margin-bottom: 30px;
              display: inline-block;
              flex-shrink: 0;
              width: 203px;
              height: 65px;
              border: 1px solid #A7AEBB;
              opacity: 1;
              border-radius: 4px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              text-align: center;
              cursor: pointer;
              margin-right: 40px;
              color: #424855;
              &.active {
                background: #A0393E;
                box-shadow: 0px 3px 6px rgba(24, 60, 80, 0.08);
                opacity: 1;
                border-radius: 4px;
                color: #FFFFFF;
              }
              > p {
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 32px;
              }
              > p:nth-child(2) {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
              }
              &.disable {
                pointer-events: none;
                opacity: 0.5;
              }
            }
          }
          .time-select-text {
            line-height: 44px;
            color: #ec2f2f;
          }
          .select-btn {
            float: right;
            width: 203px;
            height: 44px;
            line-height: 44px;
            border-radius: 6px;
            .input-show {
              display: block;
              width: 100%;
              height: 100%;
              line-height: 44px;
              text-align: center;
              height: 44px;
              background: #f6f6f6;
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              outline: none;
              text-align: center;
              &.active {
                background: #241008;
                color: #fff;
              }
              &:hover {
                opacity: 0.8;
              }
            }
            .picker-options {
              display: block;
              width: 100%;
              height: 44px;
              line-height: 44px;
              .el-input {
                width: 100% !important;
                background: #f6f6f6;
              }
            }
          }
          .buyticket-list {
          }
        }
      }
      .buyticket-footer {
        overflow: hidden;
        display: flex;
        border-top: 1px solid #f6f6f6;
        padding-top: 29px;
        margin-top: 31px;
        .booking-notice {
          flex: 1;
          height: 58px;
          line-height: 58px;
          img {
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 4px;
            cursor: pointer;
          }
          span {
            display: inline-block;
            font-size: 16px;
            color: #ec2f2f;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        .booking-msg {
          flex: 1;
          overflow: hidden;
          line-height: 58px;
          text-align: right;
          .msg {
            display: inline-block;
            vertical-align: middle;
            font-size: 16px;
            color: #333;
            span {
              display: inline-block;
              color: #ff4400;
              margin: 0 12px;
            }
          }
        }
      }
    }
    .schedule {
      position: absolute;
      right: -185px;
      top: 0;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 165px;
        height: 40px;
        background: #853D3F;
        color: #FFFFFF;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .content {
        padding: 16px 16px;
        background: white;
        padding-right: 0;
        .activity {
          color: #853D3F;
        }
      }
    }
    .dateSelect {
      margin-bottom: 16px;
      .label {
        font-weight: bold;
        line-height: 40px;
        margin-right: 15px;
      }
      .btn {
        display: inline-block;
        vertical-align: middle;
        min-width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 15px;
        border-radius: 15px;
        cursor: pointer;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .btn.right {
        float: right;
        /* right: 20px; */
      }
      .btn.current {
        color: #fff;
        background-color: #21a4ff;
      }
    }
    .ticketDetail /deep/ .el-table::before {
      height: 0;
    }
    .ticketDetail /deep/ th.is-leaf {
      background-color: #21a4ff;
      color: #fff;
      border-bottom: 12px solid #fff;
    }
    .ticketDetail /deep/ th.is-leaf:nth-child(1) {
      background: url(../assets/images/border_th_l.png) #21a4ff no-repeat left;
    }
    .ticketDetail /deep/ th.is-leaf:nth-last-child(2) {
      background: url(../assets/images/border_th_r.png) #21a4ff no-repeat right;
    }
    .ticketDetail /deep/ td {
      background-color: #f7f7f7;
      border-bottom: 12px solid #fff;
      padding: 10px 0;
    }
    .ticketDetail /deep/ td .cell {
      font-weight: bold;
    }
    .ticketDetail /deep/ td:nth-child(1) {
      background: url(../assets/images/border_td_l.png) #f7f7f7 no-repeat left;
    }
    .ticketDetail /deep/ td:nth-last-child(2) {
      background: url(../assets/images/border_td_r.png) #f7f7f7 no-repeat right;
    }
  }
}

.reserveBtn {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  border-radius: 20px;
  background-color: #ffb000;
  cursor: pointer;
}
.reserveBtn:hover {
  background-color: #faab00;
}
.mb40 {
  margin-bottom: 40px;
}
.main-box {
  // padding: 30px 0;
  padding-bottom: 50px;
  .announcements {
    width: 100%;
    min-height: 308px;
    margin-top: 20px;
    background: white;
    .title {
      position: relative;
      height: 64px;
      background: url("../assets/images/home/announcements.png");
    }
    .title :nth-child(1) {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
    }
    .title :nth-child(2) {
      position: absolute;
      top: 50%;
      right: 40px;
      transform: translateY(-50%);
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .list {
      display: flex;
      padding-top: 32px;
      padding-bottom: 20px;
      flex-wrap: wrap;
    }
    .list-item {
      width: 40%;
      display: flex;
      flex-shrink: 0;
      justify-content:space-between;
      margin-bottom: 12px;
      margin-left: 85px;
      :nth-child(1) {
        color: #0C121D;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        overflow: hidden;
        max-width: 300px;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        &:hover {
          color: #A0393E;
        }
      }
      :nth-child(1)::before{
        content: '•';
        font-size: 18px;
        padding-right: 6px;
        color: #A7AEBB;;
      }
      :nth-child(2) {
        color: #6A7792;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
  .information {
    background: white;
    margin-top: 20px;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 64px;
      background: url("../assets/images/home/announcements.png");
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .content {
      padding: 32px 70px;
    }
    /deep/ td, th {
      border:2px solid #DDD;
      // text-align: center;
    }
  }
}
.notice-dialog {
  .selctes /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #fff;
  }
  .title {
    line-height: 20px;
    height: 20px;
    overflow: hidden;
    padding-left: 20px;
    position: relative;
    margin-bottom: 34px;
    &::before {
      position: absolute;
      top: 50%;
      width: 3px;
      height: 14px;
      background: rgba(191, 147, 48, 1);
      border-radius: 2px;
      margin-top: -7px;
      left: 8px;
      content: "";
    }
  }
  .notice {
    display: block;
    // min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
    line-height: 20px;
  }
  .btn {
    width: 130px;
    height: 44px;
    background: rgba(191, 147, 48, 1);
    border-radius: 6px;
    color: #fff;
    margin: 0 21px;
    &.cancal {
      background: #ccc;
      color: #333;
    }
  }
}
.dialog-login {
  iframe {
    display: block;
    width: 100%;
    height: 400px;
  }
}
.payBtn {
  display: inline-block;
  width: 80px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  font-size: 14px;
  border-radius: 3px;
  background:#A0393E;
  color: #fff;
  cursor: pointer;
  &.disable {
    background: #f6f6f6;
    cursor: no-drop;
    color: #cdcdcd;
  }
  &:hover {
    opacity: 0.8;
  }
}
.tips {
  position: fixed;
  top: 135px;
  right: 0;
}
.right-fiex-box {
  position: fixed;
  top: 410px;
  right: 20px;
  width: 72px;
  height: 168px;
  border: 1px solid #424855;
  border-radius: 4px;
  .right-fiex-item {
    width: 72px;
    height: 72px;
    padding-top: 12px;
    // background: #853D3F;
    cursor: pointer;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    .right-fiex-top {
      width: 40px;
      height: 40px;
      background: url("../assets/images/home/tourGuide.png");
      margin: 0 auto;
    }
    >p {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
      color: #424855;
      opacity: 1;
      text-align: center;
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/tourGuideWhite.png");
      }
      >p {
        color: white;
      }
    }
  }
  .right-fiex-item2 {
    border-radius: 0px 0px 4px 4px;
    .right-fiex-top {
      background: url("../assets/images/home/tourBus.png");
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/tourBusWhite.png");
      }
      >p {
        color: white;
      }
    }
  }
}
.right-fiex-box2 {
  position: fixed;
  top: 600px;
  right: 20px;
  width: 72px;
  height: 168px;
  border: 1px solid #424855;
  border-radius: 4px;
  .right-fiex-item {
    width: 72px;
    height: 72px;
    padding-top: 12px;
    // background: #853D3F;
    cursor: pointer;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    .right-fiex-top {
      width: 40px;
      height: 40px;
      background: url("../assets/images/home/phone.png");
      margin: 0 auto;
    }
    >p {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
      color: #424855;
      opacity: 1;
      text-align: center;
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/phoneWhite.png");
      }
      >p {
        color: white;
      }
    }
  }
  .right-fiex-item2 {
    border-radius: 0px 0px 4px 4px;
    .right-fiex-top {
      background: url("../assets/images/home/qq.png");
    }
    &:hover {
      background: #853D3F;
      .right-fiex-top {
        background: url("../assets/images/home/qqWhite.png");
      }
      >p {
        color: white;
      }
    }
  }
}
.buyticket-hint {
  display: flex;
  align-items: center;
  img {
    margin-right: 9px;
  }
}
/deep/ .el-timeline-item__tail {
  width: 5px;
}
.dynamicFuzzy {
  width: 25px;
  position: absolute;
  left: -7px;
  top: 14px;
}
/deep/.timeline-line-animation .el-timeline-item__tail:after {
  content: "";
  display: inline-block;
  width: 50%;
  height: 100%;
  background: #853D3F; /* Old browsers */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2989d8', endColorstr='#2989d8',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
  background-size: 60px 30px;
  text-align: center;
  color:#fff;
  -webkit-animation:load 0.5s ease-in; //infinite
  position: absolute;
  top: 0;
  left: -40%;
}
@-webkit-keyframes load{
    0%{
      height: 0%;
    }
    100%{
      height:100%;
    }
}
</style>
